import { render, staticRenderFns } from "./reviewRubric.vue?vue&type=template&id=b3a7f27e&lang=html&"
import script from "./reviewRubric.vue?vue&type=script&lang=ts&"
export * from "./reviewRubric.vue?vue&type=script&lang=ts&"
import style0 from "./reviewRubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports